<template>
	<basic-container v-loading="!isShowContent" :block="!isShowContent">
		<div v-if="systemMessage">
			<el-alert :closable="false" :title="systemMessage" type="warning"></el-alert>
		</div>

		<div v-if="isShowContent" class="flex-container">
			<div v-for="(itemData, index) in productList" :key="index">
				<el-card
					:body-style="{padding: '15px 15px 0 15px'}"
					shadow="hover"
					style="width: 260px; height: 380px; margin-bottom: 20px">
					<el-row justify="center" type="flex">
						<img alt="" class="image" height="100px" v-bind:src="itemData.groupLogo" width="100px" />
					</el-row>
					<el-row justify="center" style="height: 32px" type="flex">
						<span style="font-size: 1em; font-weight: bold">{{ itemData.title }}</span>
					</el-row>
					<el-row justify="end" type="flex">
						<el-button type="text" @click="handleView(itemData)">查看详细>></el-button>
					</el-row>
					<el-row justify="start" type="flex">
						<span style="font-size: 1em; font-weight: bold">￥{{ itemData.price / 100 }} 起</span>
					</el-row>
					<el-row justify="start" style="margin-top: 5px; height: 20px" type="flex">
						<el-link
							v-if="isHasCategory(itemData.insureType)"
							:disabled="isDownLoading"
							icon="el-icon-download"
							style="font-size: 0.8em; margin-right: 20px"
							type="primary"
							@click="onDownloadCategory(itemData.id)">
							职业类别表
						</el-link>
						<el-link
							v-if="itemData.productIdCenter && itemData.productIdCenter !== '0'"
							:disabled="isDownLoading"
							icon="el-icon-document"
							style="font-size: 0.8em"
							type="primary"
							@click="onCreatePlan(itemData)">
							投保计划书
						</el-link>
					</el-row>
					<el-row style="margin-top: 8px; height: 80px">
						<div v-for="(item2, index2) in itemData.intros" :key="index2" style="font-size: 0.75em; padding-left: 0">
							{{ item2 }}
						</div>
					</el-row>
					<el-row justify="center" type="flex">
						<el-button
							:loading="isInsureLoading && insureType === itemData.insureType && productId === itemData.id"
							style="margin-bottom: 8px"
							type="primary"
							@click="handleInsure(itemData)">
							去投保
						</el-button>
					</el-row>
					<el-row justify="center" type="flex">
						<span style="font-size: 0.5625em; color: LightGray">承保：{{ itemData.groupName }}</span>
					</el-row>
				</el-card>
			</div>
		</div>
		<!--    投保前的弹窗-->
		<insure-begin-hint v-if="isShowInsureBegin" ref="showHint"></insure-begin-hint>

		<insure-notices ref="refInsureNotices" @onToInsure="onGoInsure"></insure-notices>
	</basic-container>
</template>

<script>
import {getProductList} from '@/api/insurance/product'

import {getPageId} from '@/util/commonUtils'
import {currentYYYYmmdd} from '@/util/date'
import {setStore} from '@/util/store'
import {handleDownCategoryFile} from '@/util/util'
import rrlog from '@meibao/traceback-record'
import {mapGetters} from 'vuex'

import {toInsureCenter} from '@/util/insureUtils'
import InsureBeginHint from '@/views/insurance/product/insureBeginHint.vue'
import {InsureNotices} from 'meibao-insure'
import {isHasCategory} from 'meibao-insure/src/util/productUtil'

export default {
	components: {
		InsureBeginHint,
		InsureNotices,
	},
	name: 'product',
	data() {
		return {
			currentItemData: {},
			insureType: '',
			productId: '',
			productList: [],
			isShowContent: false,
			showNoticeDlg: false,
			//  Added by Li Yong on 2021/12/30
			systemMessage: '',
			isDownLoading: false,
			rrlogEventId: null,
			isInsureLoading: false,
			isShowNotices: false,
			noticesData: {},
			isShowInsureBegin: false,
		}
	},
	provide() {
		return {
			insureType: this.currentItemData.insureType,
			productId: this.currentItemData.id,
		}
	},
	created() {
		this.initData()
		console.log('产品库----created')
		this.$Bus.$on('onAgreeInsure', this.onGoInsure)
	},
	beforeDestroy() {
		console.log('产品库----beforeDestroy')
		this.$Bus.$off('onAgreeInsure', this.onGoInsure)
	},
	//声明周期
	computed: {
		...mapGetters(['userInfo']),
	},
	methods: {
		isHasCategory,
		async initData() {
			let response = (await getProductList()) || {}
			let {code, data = [], msg} = response.data || {}
			if (code === 0) {
				this.systemMessage = msg
				this.productList = data
			}
			this.isShowContent = true
		},

		// 去投保
		handleInsure(itemData) {
			//保存数据
			this.currentItemData = itemData
			let {id: productId, insureType, title, informStatus, informContent, productIdCenter = ''} = itemData
			this.rrlogEventId = rrlog.capture(
				`去投保`,
				{
					productId,
					productName: title,
				},
				{
					sign: true,
				},
			)
			this.productId = productId
			this.insureType = insureType
			//产品中心
			if (productIdCenter && productIdCenter !== '0') {
				//产品中心
				this.onShowHint()
			} else {
				this.isShowInsureBegin = true
				this.$nextTick(() => {
					if (this.$refs.showHint) {
						this.$refs.showHint.showHint(insureType, productId, {informStatus, informContent})
					}
				})
			}
		},
		handleView(itemData) {
			let {id: productId, insureType, productIdCenter = ''} = itemData
			let tempUrl = productIdCenter && productIdCenter !== '0' ? '/insuranceCenter/detailsCenter' : '/product/details'
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `${tempUrl}/${insureType}`,
				}),
				query: {
					productId,
					productIdCenter,
				},
			})
		},
		handleClose() {
			this.showNoticeDlg = false
		},
		onGoInsure() {
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			let {id: productId, productIdCenter = '', insureType} = this.currentItemData
			if (productIdCenter && productIdCenter !== '0') {
				//跳转投保页
				toInsureCenter({
					act: `new`,
					pageId,
					productId: productIdCenter,
					insureType,
					sourceProductId: productId,
				})
			} else {
				this.$router.push({
					path: this.$router.$avueRouter.getPath({
						src: `/policy/entry/${productId}`,
					}),
					query: {
						act: `new`,
						pageId,
						insureType,
					},
				})
			}
			this.isShowInsureBegin = false
		},
		goInfo() {
			this.showNoticeDlg = false
			setTimeout(() => {
				this.$alert('从事拒绝承保职业的雇员不属于本保险产品的保障人员范围，还请知悉', '投保提示', {
					confirmButtonText: '我知道了',
				})
			}, 500)
		},
		onDownloadCategory(productId) {
			this.isDownLoading = true
			let fileName = `tk_${productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
					this.$message.success('下载成功')
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		onCreatePlan(itemData) {
			let {id: productId, insureType, productIdCenter = ''} = itemData
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/plan/planInsure`,
				}),
				query: {
					productId,
					productIdCenter,
					insureType,
				},
			})
		},
		onCancel() {},
		async onShowHint() {
			let {id: sourceProductId, productIdCenter: productId} = this.currentItemData
			this.isInsureLoading = true
			await this.$refs.refInsureNotices.onGetHintInfoData({productId, sourceProductId})
			this.isInsureLoading = false

			// try {
			//   let tempData = await getInsureHint({productId, sourceProductId})
			//   let {code = -1, data = {}, msg} = tempData.data || {}
			//   if (code === 0) {
			//     let {hintInfo = {}} = data
			//     this.$refs.refInsureNotices.onShowNotices(hintInfo)
			//   } else {
			//     this.$message.error(msg)
			//   }
			// } catch (e) { } finally {
			//   this.isInsureLoading = false
			// }
		},
	},
}
</script>

<style lang="scss" scoped>
.ul,
li {
	list-style-type: none;
}

.flex-container {
	/* We first create a flex layout context */
	display: flex;
	/* Then we define the flow direction
      and if we allow the items to wrap
  * Remember this is the same as:
  * flex-direction: row;
  * flex-wrap: wrap;
  */
	flex-flow: row wrap;
	/* Then we define how is distributed the remaining space */
	justify-content: space-around;

	padding: 10px;
	margin: 0;
	list-style: none;
}

/* .flex-item {
    padding: 5px;
    width: 320;
    height: 400px;
    margin-top: 10px;
    line-height: 400px;
    color: white;
    font-weight: bold;
    font-size: 3em;
    text-align: center;
} */
</style>
